import React, { VoidFunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";
import { HomePage } from "./features/HomePage/HomePage";
import { Box } from "@mui/material";
import { AlertMessages } from "sb-material-components";
import { AppHeader } from "./features/AppHeader/AppHeader";
import { AppFooter } from "./features/AppFooter/AppFooter";
import NoPage from "./features/NoPage/NoPage";

export const AppRoutes: VoidFunctionComponent = () => {
    return (
        <main>
            <AppHeader />
            <AlertMessages />
            <Box width={1} sx={{ minHeight: "calc(100vh - 64px)", overflowY: "auto" }}>
                <Routes>
                    <Route index element={<NoPage />} />
                    <Route path="/:subscriberId/:briefId/contact" element={<HomePage />} />
                </Routes>
            </Box>
            <AppFooter />
        </main>
    );
};
